const initialState = {
    searchobj: {},
  };
   
  const actions = {
    SET_SEARCH_EVENT: 'SEARCH/SET_SEARCH_EVENT',
  };
   
  export const SearchReducer = (state, action) => {
    if (typeof state === 'undefined') {
      return initialState;
    }
    if (action.type === actions.SET_SEARCH_EVENT) {
      if (action.payload?.searchobj) {
        return {
          ...state,
          searchobj: {...state?.searchobj, ...action.payload?.searchobj},
        };
      }
    }
    return state;
  };
   
  export const setSearchObj = (searchobj) => ({
    type: actions.SET_SEARCH_EVENT,
    payload: { searchobj },
  });
   
  export default SearchReducer;
  